import { useQuery } from '@tanstack/react-query'
import { z } from 'zod'

import { get } from '../apiClient'
import { API_ENDPOINTS } from '../../../common/apiEndpoints'

const rightOfAccessSchema = z.object({
  id: z.number(),
  realPropertyHierarchyId: z.number(),
  startDate: z.string(),
  endDate: z.string().nullable(),
  isTerminated: z.boolean(),
  type: z.literal('gym'),
  buildingLocationDetails: z.string(),
  buildingPartLocationDetails: z.string(),
  locationDetails: z.string(),
  additionalDetails: z.string().nullable(),
  buildingPartAddress: z.object({
    streetName: z.string(),
    streetNumber: z.string(),
    city: z.string(),
  }),
})

const rightsOfAccessResponseSchema = z.array(rightOfAccessSchema)

export type RightOfAccess = z.infer<typeof rightOfAccessSchema>

const rightsOfAccessKey = (contractUuid: string) => [
  `${API_ENDPOINTS.CONTRACTS}/${contractUuid}/rights-of-access`,
]

const path = (contractUuid: string) =>
  `/contracts/${contractUuid}/rights-of-access`

const params = (contractUuid: string) => ({
  queryKey: rightsOfAccessKey(contractUuid),
  queryFn: async () => {
    const response = await get(path(contractUuid), rightsOfAccessResponseSchema)
    return response
  },
})

export const useAPIGetRightsOfAccess = (contractUuid: string) => {
  return useQuery(params(contractUuid))
}
